export const enum PLPQueryParams {
	order = 'order',
	filters = 'filters',
	range = 'range',
	collection = 'collection',
}

export const ALL_PLP_QUERY_PARAMS = [
	PLPQueryParams.order,
	PLPQueryParams.filters,
	PLPQueryParams.range,
	PLPQueryParams.collection,
]
